import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { updateMetaField } from 'Services/JOONAdmin/joonAdminEmployersService'

export const useUpdateMetaFieldQuery = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.UpdateMetaField], updateMetaField, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.EmployerMetaFields])
        queryClient.invalidateQueries([QueryNames.UsersForEmployer])
        queryClient.invalidateQueries([QueryNames.UsersWithMetadata])
        toast.success(AppNotification.UpdateMetaFieldSuccess)
      } else {
        toast.error(response.message || AppNotification.UpdateMetaFieldFailure)
      }
    },
    onError: () => {
      toast.error(AppNotification.UpdateMetaFieldFailure)
    }
  })
}
